import { createContext, useContext } from "react";

import { DirtyFormContextValue } from "./DirtyFormContextProvider.types";

const defaultValue: DirtyFormContextValue = {
  registerDirtyForm: () => {},
  unregisterDirtyForm: () => {},
  clearAllDirtyForms: () => {},
  isDirty: false,
};

export const DirtyFormContext = createContext<DirtyFormContextValue>(defaultValue);
export const useDirtyFormContext = (): DirtyFormContextValue => useContext(DirtyFormContext);
